import React, { Fragment } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ThemeLayout from "./components/ThemeLayout";
import Main from "./containers/Main";
import { routes } from "./utils/routes";
import TopUpReturnBridge from "./features/finance/TopUpReturnBridge";

function AppContainer() {

  return (
    <ThemeLayout>
      <BrowserRouter>
        <Main>
          <TopUpReturnBridge />

          <Routes>
            <Fragment>
              {routes.map(({ component, isProtected, ...routeProps }) => (
                <Route element={component} {...routeProps} />
              ))}
              <Route path="*" element={<Navigate to="/" />} />
            </Fragment>
          </Routes>
        </Main>
      </BrowserRouter>
    </ThemeLayout>
  );
}

export default AppContainer;
